
import {
  defineComponent,
  reactive,
  toRefs,
  ref,
  onBeforeMount,
  inject,
} from "vue";
import { UploadProps, UploadUserFile, ElMessage } from "element-plus";
import userService from "@/network/user";
import { store } from "@/store";
import type { FormRules } from "element-plus";
import { t } from "@/languages"
export default defineComponent({
  emits: ["getUserinformation"],
  setup(props, content) {
    const photoUrl = ref<UploadUserFile[]>([]);
    let data = reactive({
      isEdituser: false, //判断是否编辑用户
      isEditphone: false, //判断是否编辑手机号
      isEditavatar: false, //判断是否编辑头像
      formData: {
        username: "", //用户名
        account: "", //账号
        id: "", //人员id
        jobNumber: "", //工号
        phone: "", //手机号
        region: "", //区域
        roleName: "", //角色
        teamName: "", //组织名称
        avatar: "", //头像
      },
      form: {
        updatePhone: "", //修改手机号
        updateUsername: "", //修改用户名
      },
      upadteAvatar: "", //修改头像
      certificateList: [
        {
          deadtime: "", //选泽证书时间
          certificateName: "", //证书名字
          id: "",
          photoUrl: "",
          imgList: [""], //图片数组
        },
      ],
    });
    /* 改变头像展示 */
    function showUpdateavatar(uploadFile: any) {
      data.upadteAvatar = uploadFile.url;
    }
    /* 关闭编辑头像 */
    function closeAvatar() {
      data.isEditavatar = false;
      data.upadteAvatar = data.formData.avatar;
    }
    /* 单文件上传 */
    async function aloneFileupload() {
      if (!photoUrl.value[0]) {
        data.isEditavatar = false;
        ElMessage.success(t("890"));
        return;
      }
      const file = photoUrl.value[photoUrl.value.length - 1].raw;
      await userService.uploadAvatarFile({ file: file }, true).then((res) => {
        data.upadteAvatar = res.resultData.url;
        changeUseravatar();
      });
    }

    /* 修改用户账号 */
    async function changeUsername() {
      if (
        data.form.updateUsername.trim() === "" ||
        data.form.updateUsername.trim() === null
      ) {
        return;
      }
      await userService
        .updateUsername({
          username: data.form.updateUsername,
          userId: data.formData.id,
        })
        .then(
          (res) => {
            data.isEdituser = false;
            if (res.resultStatus) {
              ElMessage.success(t("891"));
              getUser();
              store.dispatch("changeUsername", data.form.updateUsername);
              let userInfo: any = JSON.parse(
                localStorage.getItem("userInfo") as any
              );
              userInfo.username = data.form.updateUsername;
              localStorage.setItem("userInfo", JSON.stringify(userInfo));
            }
          },
          (error: any) => {
            console.log(error);
            ElMessage.success(t("892"));
          }
        );
    }

    /* 修改用户手机号 */
    async function changeUserphone() {
      if (
        data.form.updatePhone.trim() &&
        !/^(?:(?:\+|00)86)?1\d{10}$/.test(data.form.updatePhone)
      ) {
        return;
      }
      await userService
        .updateUserphone({
          phone: data.form.updatePhone.trim(),
          userId: data.formData.id,
        })
        .then(
          (res) => {
            data.isEditphone = false;
            res.resultStatus && ElMessage.success(t("893"));
            let userInfo: any = JSON.parse(
              localStorage.getItem("userInfo") as any
            );
            userInfo.phone = data.form.updatePhone;
            localStorage.setItem("userInfo", JSON.stringify(userInfo));
            getUser();
          },
          (error: any) => {
            console.log(error);
            ElMessage.success(t("894"));
          }
        );
    }

    /* 修改用户头像 */
    async function changeUseravatar() {
      await userService
        .updateUseravatar({
          avatar: data.upadteAvatar,
          id: data.formData.id,
        })
        .then(
          (res) => {
            data.isEditavatar = false;
            res.resultStatus && ElMessage.success(t("890"));
            photoUrl.value = [];
            getUser();
            store.dispatch("changeAvatar", data.upadteAvatar);
            let userInfo: any = JSON.parse(
              localStorage.getItem("userInfo") as any
            );
            userInfo.avatar = data.upadteAvatar;
            localStorage.setItem("userInfo", JSON.stringify(userInfo));
          },
          (error: any) => {
            console.log(error);
            ElMessage.success(t("895"));
          }
        );
      data.upadteAvatar = "";
    }

    /* 切换信息编辑*/
    async function changeEdit(changeType: string) {
      switch (changeType) {
        case "user":
          await changeUsername();
          break;
        case "phone":
          await changeUserphone();
          break;
        case "avatar":
          await aloneFileupload();
          break;
      }
    }

    /* 检查证书上传的文件类型 */
    const beforeAvatarUpload: UploadProps["beforeUpload"] = (rawFile) => {
      let imgType: string[] = ["image/jpg", "image/png", "image/svg"];
      if (!imgType.includes(rawFile.type)) {
        ElMessage.error("Avatar picture must be JPG format!");
        return false;
      }
      return true;
    };

    /* 获取用户基本信息 */
    async function getUser() {
      await userService.getUserinformation(data.formData.id).then(
        (res: any) => {
          data.formData = { ...data.formData, ...res.resultData };
          data.form.updatePhone = res.resultData.phone;
          data.form.updateUsername = res.resultData.username;
          data.upadteAvatar = res.resultData.avatar;
          transmitUser();
        },
        (err: any) => {
          ElMessage.error(t("644"));
          console.log(err);
        }
      );
    }

    /* 获取用户飞行证书列表 */
    async function initCertificateList() {
      data.certificateList = [
        {
          deadtime: "",
          certificateName: "",
          id: "",
          photoUrl: "",
          imgList: [],
        },
      ];
      await userService
        .getCertificateList(data.formData.id)
        .then((res) => {
          timer.splice(0);
          if (res.resultData) {
            data.certificateList = [...res.resultData];
            data.certificateList.forEach((item) => {
              item.deadtime = item.deadtime.slice(0, 10);
              item.imgList = item.photoUrl.split(";");
              const nowTime = timestampToTime(new Date().getTime());
              diffTimeHour(nowTime, item.deadtime);
            });
          }
        })
        .catch(() => {
          ElMessage.error(t("879"));
        });
    }
    /* 跳转到证书 */
    const activePath: any = inject("activePath");

    /* 传递用户数据给父组件 */
    function transmitUser() {
      content.emit("getUserinformation", {
        avatar: data.formData.avatar,
        jobNumber: data.formData.jobNumber,
      });
    }
    /* 初始化 */
    async function init() {
      await getUser();
      await initCertificateList();
    }
    onBeforeMount(() => {
      console.log(props);
      const userInfo = store.state as any;
      data.formData.id =
        userInfo.user.userInfo.id || localStorage.getItem("userInfo");
      init();
    });

    //时间戳转化为时间格式xxxx-xx-xx
    function timestampToTime(timestamp: any) {
      let date = new Date(timestamp);
      let Y = date.getFullYear() + "-";
      let M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      let D =
        (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
      return Y + M + D;
    }

    //比较两个时间差
    let timer: number[] = reactive([]); //存时间差
    function diffTimeHour(oldTime: any, newTime: any) {
      const timeDiff =
        new Date(newTime.replace(/-/g, "/")).getTime() -
        new Date(oldTime.replace(/-/g, "/")).getTime();
      const formatTimeDiff = timeDiff / (3600 * 1000 * 24);
      timer.push(formatTimeDiff);
    }

    // 表单验证
    let validatePhone = (rule: any, value: any, callback: any) => {
      //使用正则表达式进行验证手机号码

      if (value.trim() && !/^(?:(?:\+|00)86)?1\d{10}$/.test(value)) {
        callback(new Error(t("896")));
      }
    };
    let validateUse = (rule: any, value: any, callback: any) => {
      if (!value.trim()) {
        callback(new Error(t("897")));
      }
    };
    const formRues = reactive<FormRules>({
      updatePhone: [{ validator: validatePhone, trigger: ["change", "blur"] }],
      updateUsername: [{ validator: validateUse, trigger: ["change", "blur"] }],
    });

    return {
      ...toRefs(data),
      activePath,
      timer,
      photoUrl,
      changeEdit,
      beforeAvatarUpload,
      getUser,
      initCertificateList,
      aloneFileupload,
      showUpdateavatar,
      closeAvatar,
      timestampToTime,
      diffTimeHour,
      formRues,
    };
  },
});
